import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import { BASE_URL } from "@/constants/constants";
import { literals } from "@/constants/literals";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CloseReceptionOrderModal from "./components/ConfirmExitsModal";
import GroupDetail from "@/pages/capture/components/GroupDetail";
import useExitsDataStore from "@/store/useExitsData.store";
import ExitsOrderHeader from "../components/ExitsOrderHeader";

const ExitsResumePage = () => {
  const [viewModal, setViewModal] = useState(false);
  const { exitsGroupData } = useExitsDataStore();
  const navigate = useNavigate();

  const handleOnAddMore = () => {
    navigate(`${BASE_URL}/capture/exits/new-group`);
  };

  const noGroupsInData = useMemo(
    () => !exitsGroupData || exitsGroupData.length === 0,
    [exitsGroupData],
  );

  const handleOnContinue = () => {
    if (!noGroupsInData) {
      setViewModal(true);
    }
  };

  const onClose = () => {
    setViewModal(false);
  };

  return (
    <div className="min-h-fulldpx flex flex-col justify-between bg-ib-pt-color-white">
      <div className="flex-1">
        <ExitsOrderHeader />
        <div className="p-4 md:px-14 md:py-6">
          <ul className="w-full flex flex-col gap-4 md:flex-row md:flex-wrap items-stretch">
            {exitsGroupData.map((group) => {
              return (
                <li
                  key={group.id}
                  className="w-full md:w-[calc((100%-16px)/2)] lg:w-[calc((100%-32px)/3)]"
                >
                  <GroupDetail group={group} stand="exits" />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="w-full p-4 md:px-0 flex flex-col md:flex-row md:justify-around gap-4 md:gap-0 border-t border-ib-pt-color-gray-300 md:items-center">
        <div className="md:capture-button">
          <SecondaryButton
            colour="red"
            label={
              !noGroupsInData
                ? literals.uploadMorePhotos
                : literals.uploadPhotoGroup
            }
            onClick={handleOnAddMore}
          />
        </div>
        <div className="md:capture-button">
          <PrimaryButton
            size="medium"
            label={literals.continue}
            colour="red"
            type="submit"
            onClick={handleOnContinue}
            disabled={noGroupsInData}
          />
        </div>
      </div>
      <CloseReceptionOrderModal onClose={onClose} viewModal={viewModal} />
    </div>
  );
};

export default ExitsResumePage;
